import { createContext, useContext } from "react";

// Metadata stored for each presence entry
export type PresenceMeta = {
  user_id?: string;
  email?: string | null;
  online_at?: string;
  [k: string]: unknown;
};

// Context type describing presence data shared across the app
export interface PresenceContextType {
  presenceMap: Map<string, PresenceMeta[]>;
  isOnline: boolean;
  getUserPresence: (userId: string) => PresenceMeta[];
}

// React context holding presence state and helpers
export const PresenceContext = createContext<PresenceContextType | undefined>(
  undefined,
);

// Hook to consume presence context and enforce provider usage
export function usePresenceContext() {
  const context = useContext(PresenceContext);
  if (context === undefined) {
    throw new Error(
      "usePresenceContext must be used within a PresenceProvider.",
    );
  }
  return context;
}
